import { REQUEST_CREATE_VIEW_TYPE } from '../../constants';
import { getSupportedFieldConfiguration } from '../../fake-uim/store';
import type { FieldForInitialize } from '../../fake-uim/store/types';
import type { FieldState } from 'state/persisted/request-create/types';

interface GetValueByInitializeFieldProprtyMappingPayload<DEFAULT_VALUE> {
    field: FieldState;
    fieldType: string;
    property: keyof FieldForInitialize;
    defaultValue?: DEFAULT_VALUE;
}

export const getValueByInitializeFieldProprtyMapping = <RESULT, DEFAULT_VALUE = undefined>({
    field,
    fieldType,
    property,
    defaultValue = undefined,
}: GetValueByInitializeFieldProprtyMappingPayload<DEFAULT_VALUE>) => {
    const mappedProperty =
        // TODO: replace with real getSupportedFieldsConfiguration once uim is ready on platfrom.
        getSupportedFieldConfiguration(REQUEST_CREATE_VIEW_TYPE, fieldType)?.initializeFieldProprtyMapping?.[
            property
        ] ?? property;

    return (field?.[mappedProperty as keyof FieldState] as RESULT) ?? defaultValue;
};
